<div class="container-summary preview-summary-container card-base-design">
    <h2 class="ra-header-s">{{ 'document.preview.summary.title' | translate }}</h2>

    <div class="preview-summary-list">
        @for (entry of titledSections(); track entry.session._id || $index) {
            @let sectionNum = $index + 1;
            <!-- Nível 1: Número + Título da seção (item TITLE).
                 Seções sem item TITLE não aparecem no sumário. -->
            <button
                type="button"
                class="preview-summary-item preview-summary-item--level1"
                (click)="goTo(entry.title?._id)">
                <span class="preview-summary-number ra-label-s">{{ sectionNum }}-</span>
                <div class="preview-summary-text ra-label-s">
                    <ra-viewer-text [content]="entry.title?.value" />
                </div>
            </button>

            <!-- Nível 2: Número.Número + Sub-título -->
            @for (item of getSubtitles(entry.session); track item._id || $index) {
                <button
                    type="button"
                    class="preview-summary-item preview-summary-item--level2"
                    (click)="goTo(item?._id)">
                    <span class="preview-summary-number ra-label-s">{{ sectionNum }}.{{ $index + 1 }}-</span>
                    <div class="preview-summary-text ra-label-s">
                        <ra-viewer-text [content]="item?.value" />
                    </div>
                </button>
            }
        }
    </div>
</div>
